import { render, staticRenderFns } from "./BucketDetailsTab.vue?vue&type=template&id=143e2e56"
import script from "./BucketDetailsTab.vue?vue&type=script&lang=js"
export * from "./BucketDetailsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports